import React from 'react'
import { Switch } from '@/components/ui/switch'

export default (props) => {
  return <Switch checked={props.checked ?? props.isChecked} onCheckedChange={props.onCheckedChange || props.onChange}>{props.children}</Switch>
}
